<template>
  <div :class="formData.length < 2 ? 'padding-top-20':'padding-top-10'"
       @mouseleave="onMouseLeave" @mouseover="onMouseOver"
       style="overflow:auto;height: 100%">


    <div class="btn-content" v-show="showButton">
      <!--<img v-show="showBtn" @click="edit" ref="btnEdit" alt="编辑" class="hidden btn btn-edit" src="@/assets/images/icon/edit.png">-->
      <img @touchstart="deleteLayout" @click="deleteLayout" alt="删除" class="hidden btn btn-delete" ref="btnDelete"
           src="../../../assets/images/icon/delete.png"
           v-show="showBtn">
    </div>
    <vue-seamless-scroll :class-option="formData.length > 2 ? classOption : null" :data="formData"
                         style="height: 100%;overflow:hidden;"
                         v-if="formData.length > 0">
      <div :key="index" class="margin-top-10" v-for="(item,index) in formData">
        <!--名称-->
        <el-row :class="formData.length < 2 ? 'margin-bottom-20':'margin-bottom-10'"
                class="text-center font-weight-bold"
                style="font-size: 1.1rem;min-height: 24px;">{{
            item.name
          }}
        </el-row>
        <!--测点-->
        <div style="padding-left: 45px">
          <el-row :key="pointItem.pointId + i" class="margin-top-10" v-for="(pointItem, i) in item.pointList">
            <span v-if="pointItem.pointId">
            <img :src="$ftpUrl + item.icon" :width="22" v-if="item.icon">
              <span style="margin-left: 10px;"><span class="text-blueGrey">{{
                  pointItem.pointName
                }}</span>：
                <span :style="{color: pointItem.isHasAlarm ? 'red' : '#fff'}">{{
                    pointItem.pointValue
                  }}{{ pointItem.unit }}</span>
              </span>
            </span>
          </el-row>
        </div>
        <!--曲线-->
        <el-row :class="formData.length < 2 ? 'twoLine':'oneLine'"
                v-if="item.lineData && item.lineData.data.length > 0">
          <dynamic-line-chart :data="item.lineData" ref="lineChart"
                              style="height: 100%;"></dynamic-line-chart>
        </el-row>
      </div>

    </vue-seamless-scroll>
  </div>
</template>

<script>
import DynamicLineChart from "@/components/echarts/DynamicLineChart";
import {deleteCustomLayout} from "@/network/device-custom-layout";
import {getPointValues} from "@/network/measuring-point-history";
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  name: "pointViewDrag",
  components: {DynamicLineChart, vueSeamlessScroll},
  inject: ['reload'],
  props: ['layoutData', 'showButton'],
  data() {
    return {
      showBtn: false,
      layoutFormData: [],
      formData: [],
      lineValue: {},
      lineTime: {}
    }
  },
  computed: {
    classOption() {
      return {
        step: 0.3, //数值越大速度滚动越快
        limitMoveNum: 0, //开始无缝滚动的数据量  //this.alarmList.length
        hoverStop: true, //是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, //开启数据实时监控刷新dom
        // singleHeight: 0, //单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, //单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, //单步运动停止的时间(默认值1000ms),
      };
    },
  },
  mounted() {
    this.layoutFormData = this.layoutData.paramsData.formData
    this.getPointValues();
  },
  watch: {
    layoutData() {
      this.layoutFormData = this.layoutData.paramsData.formData
      this.getPointValues();
    }
  },
  methods: {
    getPointValues() {
      let devicePointValueDtos = [];
      this.layoutFormData.forEach(item => {
        devicePointValueDtos = devicePointValueDtos.concat(item.pointList)
      })
      devicePointValueDtos = devicePointValueDtos.map(item => item.pointId);
      getPointValues(devicePointValueDtos).then(res => {
        if (res.code === 0) {
          this.layoutFormData = this.layoutFormData.map(item => {
            item.pointList = item.pointList.map(point => {
              const deviceInfoWithItem = res.data[point.pointId];
              if (deviceInfoWithItem) {
                item.icon = deviceInfoWithItem.deviceInfoWithIcon?.iconTopological;
                point.pointValue = deviceInfoWithItem.history?.pointValue.toFixed(2);
                point.unit = deviceInfoWithItem.history?.pointUnit
                point.isHasAlarm = deviceInfoWithItem.isHasAlarm
                return point;
              }
            })
            if (item.lineData) {
              item.lineData.data = item.lineData.data.map((line, index) => {
                const deviceInfoWithItem = res.data[line.id];
                const history = deviceInfoWithItem.history;
                if (history) {
                  //测点曲线值
                  if (this.lineValue[history.pointId] === undefined) {
                    this.lineValue[history.pointId] = [];
                  }
                  if (this.lineValue[history.pointId].length > 4) {
                    this.lineValue[history.pointId].shift();
                  }
                  this.lineValue[history.pointId].push(history.pointValue)
                  line.value = this.lineValue[history.pointId]
                  //测点曲线单位
                  line.unit = history.pointUnit
                  //测点曲线时间
                  if (index === 0) {
                    let minute = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
                    let second = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
                    if (this.lineTime[history.pointId] === undefined) {
                      this.lineTime[history.pointId] = [];
                    }
                    if (this.lineTime[history.pointId].length > 4) {
                      this.lineTime[history.pointId].shift();
                    }
                    this.lineTime[history.pointId].push(new Date().getHours() + ":" + minute + ":" + second)
                    item.lineData.time = this.lineTime[history.pointId];
                  }
                }
                return line;
              })
            }
            return item;
          })
          this.formData = this.layoutFormData
        }
      })
    },
    //鼠标移入
    onMouseOver() {
      this.showBtn = true;
    },
    //鼠标移出
    onMouseLeave() {
      this.showBtn = false;
    },
    //删除布局
    deleteLayout() {
      this.$confirm('是否确认删除该组件', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            deleteCustomLayout(this.layoutData.id).then(res => {
              if (res.code === 0) {
                this.$message.success("删除成功!")
                this.reload();
              } else {
                this.$message.error("删除失败!")
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.btn-content {
  position: absolute;
  right: 10px;
  z-index: 99;
}

.oneLine {
  height: 135px;
  padding: 0 10px;
}

.twoLine {
  height: 220px;
  padding: 0 10px;
}
</style>
